module.exports = __webpack_public_path__ + "img/microplastics-inspect-small.b57965b5.png";